export default "__VITE_ASSET__C3aqJu3n__"